/**
 * Premium client cards. Each client renders with its real logo.
 * NGCC, NCS and Geoscape ship as light marks on dark backgrounds, so their
 * cards use a navy logo plate to keep the logo legible.
 */
const clients = [
  {
    name: "Nigerian-German Chamber of Commerce",
    short: "NGCC",
    sector: "Bilateral Trade",
    site: "https://ngcc-ng.com/",
    logo:
      "https://customer-assets.emergentagent.com/job_ascentix-leadership/artifacts/kispmj2b_image.png",
    plate: "dark",
  },
  {
    name: "Nigerian Chamber of Shipping",
    short: "NCS",
    sector: "Maritime & Shipping",
    site: "https://nigerian-shipping.org/",
    logo:
      "https://customer-assets.emergentagent.com/job_ascentix-leadership/artifacts/pwwfbzh0_image.png",
    plate: "light",
  },
  {
    name: "Olisa Agbakoba Legal",
    short: "OAL",
    sector: "Legal",
    site: "https://oal.law/",
    logo:
      "https://oal.law/wp-content/uploads/2025/10/imgi_2_Olisa-Agbakoba-Legal-OAL-Logo.png",
    plate: "light",
  },
  {
    name: "ProvidusBank",
    short: "Providus",
    sector: "Banking & Finance",
    site: "https://www.providusbank.com/",
    logo:
      "https://customer-assets.emergentagent.com/job_ascentix-leadership/artifacts/6ikahtmi_image.png",
    plate: "light",
  },
  {
    name: "Geoscape",
    short: "Geoscape",
    sector: "Geospatial Services",
    site: "https://geoscapeltd.com/",
    logo:
      "https://geoscapeltd.com/wp-content/uploads/2024/10/WHITE-2048x732.png",
    plate: "dark",
  },
];

function LogoPlate({ logo, alt, plate }) {
  const dark = plate === "dark";
  return (
    <div
      className={`size-16 shrink-0 rounded-xl flex items-center justify-center overflow-hidden p-2 border ${
        dark
          ? "bg-slate-900 border-slate-900/15"
          : "bg-white border-slate-900/5"
      }`}
    >
      <img
        src={logo}
        alt={alt}
        className="max-w-full max-h-full object-contain"
        loading="lazy"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    </div>
  );
}

export default function Clients() {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-24 md:py-32 bg-[#f4f1ea]/40"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">Trusted Partners</span>
          <h2
            data-testid="clients-headline"
            className="font-display mt-4 text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-slate-900"
          >
            Trusted by organisations across{" "}
            <span className="text-orange-600">commerce, finance, law and shipping</span>.
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-slate-600 max-w-[620px]">
            From financial services and law to chambers of commerce, maritime
            organisations and specialist consultancies — we partner with teams
            ready to grow.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {clients.map((c, i) => (
            <a
              key={c.name}
              href={c.site}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`client-card-${i}`}
              className="reveal lift-card group rounded-2xl bg-white border border-slate-900/5 px-6 py-7 min-h-[150px] flex items-center gap-5"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <LogoPlate logo={c.logo} alt={`${c.name} logo`} plate={c.plate} />
              <div className="min-w-0">
                <p className="font-display-medium text-[16px] leading-snug text-slate-900 tracking-tight group-hover:text-orange-700 transition-colors">
                  {c.name}
                </p>
                <p className="mt-1 text-[12px] uppercase tracking-[0.18em] text-slate-500">
                  {c.sector}
                </p>
              </div>
            </a>
          ))}
          {/* And many more card */}
          <div
            data-testid="client-card-more"
            className="reveal rounded-2xl border border-dashed border-orange-300 bg-orange-50/40 px-6 py-7 min-h-[150px] flex items-center"
          >
            <div>
              <div className="font-display text-[20px] text-orange-600">
                & more
              </div>
              <p className="text-[13px] text-slate-600 mt-1">
                Across commercial, financial, legal & maritime clients across
                Nigeria.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
